<template>
    <div class="terms">
        <div v-if="allowRouter">
            <div class="normal-banner banner-spacing">
                <picture>
                    <source
                        :data-srcset="`${$scope.CDN_IMAGES}/images/site/termos/termos-gerais-de-uso-topo-1000-mobile.jpg?auto=compress,format&q=65`"
                        media="(max-width: 768px)"
                    />
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/site/termos/termos-gerais-de-uso-topo-1250.png?auto=compress,format&q=65`"
                        alt="Banner Termos"
                        class="lazy img-responsive center-block"
                    />
                </picture>
            </div>
            <div class="long-banner banner-spacing" />
            <div class="content flex-wrap text-center topics" v-if="menuItems">
                <router-link
                    v-for="item in menuItems"
                    :key="item.id"
                    :to="contextLink === 'painel' ? panelLink + item.link : item.link"
                    class="d-inline-flex topic-box text-no-decoration"
                    :class="{
                        'selected-topic': path === item.link,
                    }"
                >
                    <img
                        class="lazy img-responsive topic-img"
                        :src="`${$scope.CDN_IMAGES}/images/site/termos/${item.img}.png?auto=compress,format&q=65`"
                        :alt="item.name"
                    />
                    <h4 class="topic-text" style="align-self: center">
                        {{ item.name }}
                    </h4>
                </router-link>
            </div>
            <span id="main" style="top: 40px" />
            <hr class="terms-hr" />
        </div>
        <div class="content" v-if="allowRouter">
            <router-view />
        </div>
        <div v-else>
            <ol class="edit-ol">
                <PainelTerms :show-plane-mode="!allowRouter"></PainelTerms>
                <ProductTerms :show-plane-mode="!allowRouter"></ProductTerms>
                <ArtTerms :show-plane-mode="!allowRouter"></ArtTerms>
                <PriceTerms :show-plane-mode="!allowRouter"></PriceTerms>
                <CarrierTerms :show-plane-mode="!allowRouter"></CarrierTerms>
                <PartnerExchangeTerms :show-plane-mode="!allowRouter"></PartnerExchangeTerms>
                <PhotoTerms :show-plane-mode="!allowRouter"></PhotoTerms>
                <MktTerms :show-plane-mode="!allowRouter"></MktTerms>
                <ContactTerms :show-plane-mode="!allowRouter"></ContactTerms>
            </ol>
        </div>
    </div>
</template>

<script>
    import cr$, { scrollToPosition } from '../../../submodules/src/script/crquery';
    import PainelTerms from './terms/PainelTerms';
    import PhotoTerms from './terms/PhotoTerms';
    import ArtTerms from './terms/ArtTerms';
    import ProductTerms from './terms/ProductTerms';
    import MktTerms from './terms/MktTerms';
    import PriceTerms from './terms/PriceTerms';
    import CarrierTerms from './terms/CarrierTerms';
    import PartnerExchangeTerms from './terms/PartnerExchangeTerms';
    import ContactTerms from './terms/ContactTerms';

    export default {
        name: 'PartnershipTerms',

        components: {
            ContactTerms,
            PartnerExchangeTerms,
            CarrierTerms,
            PriceTerms,
            MktTerms,
            ProductTerms,
            ArtTerms,
            PhotoTerms,
            PainelTerms,
        },

        props: {
            topic: {
                type: Object,
            },
            allowRouter: {
                default: true,
                type: Boolean,
            },
        },

        data() {
            return {
                menuItems: [
                    {
                        name: 'Painel e Loja',
                        link: '/painel',
                        img: 'celular_termos',
                    },
                    {
                        name: 'Envio de fotos',
                        link: '/fotos',
                        img: 'foto_termos',
                    },
                    {
                        name: 'Estampas',
                        link: '/estampas',
                        img: 'arte_termos',
                    },
                    {
                        name: 'Produtos',
                        link: '/produtos',
                        img: 'caixa_termos',
                    },
                    {
                        name: 'Divulgação e MKT',
                        link: '/divulgacao',
                        img: 'megafone_termos',
                    },
                    {
                        name: 'Preços e ganhos',
                        link: '/precos',
                        img: 'valor_termos',
                    },
                    {
                        name: 'Fretes e entregas',
                        link: '/fretes',
                        img: 'caixas_termos',
                    },
                    {
                        name: 'Trocas e devoluções',
                        link: '/trocas',
                        img: 'troca_termos',
                    },
                    {
                        name: 'Atendimento',
                        link: '/atendimento',
                        img: 'contato_termos',
                    },
                ],
                panelLink: '/termos-e-condicoes',
                path: '/' + window.location.pathname.split('/').pop(),
            };
        },

        watch: {
            $route: {
                immediate: true,
                handler(to) {
                    if (to) {
                        this.path = '/' + to.path.split('/').pop();
                        if (to.name && !to.name.includes(':')) {
                            return cr$.byId('main').scrollIntoView();
                        } else {
                            this.$nextTick(() => {
                                this.scrollIntoView();
                            });
                        }
                    }
                },
            },
        },

        computed: {
            contextLink() {
                return this.$scope.REQUEST_URI.replace(/^\/([^\/]*).*$/, '$1');
            },
        },

        methods: {
            scrollIntoView() {
                const pageContent = cr$.byClass('page-content-wrapper');
                const mainTermContent = cr$.byId('main');

                if (!mainTermContent.exists() || !pageContent.exists()) {
                    return;
                }

                const scrollY = Math.floor(
                    cr$.byId('main').raw.getBoundingClientRect().top +
                        pageContent.raw[0].scrollTop -
                        30
                );

                pageContent.scrollTo(0, scrollY, 500);
            },
        },
    };
</script>
